export const markerIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="34" viewBox="0 0 24 34">
  <path
    fill="#000000"
    d="M12 0C5.4 0 0 5.4 0 12c0 8.8 12 22 12 22s12-13.2 12-22C24 5.4 18.6 0 12 0z"
  />
  <circle cx="12" cy="12" r="4" fill="#ffffff"/>
</svg>
`;
